/* eslint-disable security/detect-object-injection */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-no-literals */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */
import React, { useCallback, useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { DataTable, DisplayColumn } from '@jutro/legacy/datatable';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import { LoaderExt } from 'gw-components-platform-react';
import { Icon, ModalNextContext } from '@jutro/components';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';

import {
    withViewModelService,
    ViewModelForm,
} from '@xengage/gw-portals-viewmodel-react';

import { PolicyService } from 'gw-capability-policy';
import { Button } from '@jutro/legacy/components';
import metadata from './MyProfilePage.metadata.json5';
import styles from './MyProfilePage.module.scss';
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';

const NotificationDescription  = {
    BillingInvoiceReady: {
        name: "Invoice Ready",
        value: "An invoice has billed and is ready"
    },
    BillingInvoiceReminder : {
        name: "Invoice Reminder",
        value: "An invoice is unpaid and due soon"
    },
    NOC: {
        name: "Notice of Cancellation",
        value: "A Notice of Cancellation has been generated"
    },
    PayrollReport: {
        name: "Payroll Reminder",
        value: "A payroll report is unfinished and due soon"
    },
    Paperless: {
        name: "Paperless",
        value: "Paperless Notification"
    },
    ClaimsUpdate: {
        name: "Claims Update",
        value: "A claim has updated with change to status, reserves or maximum medical improvement"
    },
    NewDocument: {
        name: "New Document",
        value: "An account/policy document has been posted"
    },
    LossRunSubscription: {
        name: "Loss Run Subscription (PDF)",
        value: "Receive loss run report while at least one policy is in force"
    },
    LossRunSubscriptionXL: {
        name: "Loss Run Subscription (EXCEL)",
        value: "Receive loss run report while at least one policy is in force"
    }
};

function MyProfilePage(props) {

    const ModalNext = useContext(ModalNextContext);
    const { authHeader } = props;
    const [isLoading, setIsLoading] = useState(true);
    const [optIns, setOptIns] = useState([]);
    const [userData,setUserData]=useState(undefined);
    const [disableLossRunSubscription, setDisableLossRunSubscription] = useState(false);
    const [trackGAPageView] = useGoogleAnalytics();

    const handleRoute = () => {
        const { history } = props;

        history.push('/');
    };

    const getActivePolicyForLossRunSubscription = useCallback(() =>{
        PolicyService.getAllAvailableAccountPolicySummaries_Ext(authHeader).then((policyData) => {
            if(policyData){
                let showFlag=0;

                for (let i = 0; i < policyData.length; i++) {
                    if (policyData[i].displayStatus === "In Force" || policyData[i].displayStatus === "Scheduled" || policyData[i].displayStatus === "Pending Cancellation") {
                        showFlag++;
                        break;
                    }
                }

                if (showFlag === 0) {
                    setDisableLossRunSubscription(true);
                }
            }
        }).catch(() => {
            console.log('error getting policy details to check lossrun');
        });
    },[authHeader]);

    useEffect(() => {
        getActivePolicyForLossRunSubscription();
        EnrollmentService.getUser(props.userInfo.email,authHeader)
            .then((resultObject) => {
                const userInfo =resultObject;

                // Logic for invoiceStreams Access
                for(let i = 0;i < userInfo.accountInformation.length; i ++)
                {
                    userInfo.accountInformation[i].invoiceStreamCount = userInfo.accountInformation[i].invoiceStreams.length;

                    const b = [];
                    const result = userInfo.roles.filter((o) => o.access === userInfo.accountInformation[i].accountNumber);

                    if (result.length !== 0) {
                        const streamResult = result.reduce((catsSoFar, { access, description }) => {
                            if (!catsSoFar[access]) {
                                catsSoFar[access] = [];
                            }

                            catsSoFar[access].push(description);

                            return catsSoFar;
                        }, {});
                        const gArray = Object.entries(streamResult);

                        // eslint-disable-next-line guard-for-in
                        for (const inv in userInfo?.accountInformation[i]?.invoiceStreamMap) {
                            const invName = userInfo?.accountInformation[i]?.invoiceStreamMap[inv];
                            const resultFilter = gArray[0][1].includes(inv);

                            if(resultFilter===true){
                                b.push(invName);
                            }
                        }
                    }

                    userInfo.accountInformation[i].invoiceStreams =[];
                    userInfo.accountInformation[i].invoiceStreams = b;
                }

                // Logic for invoiceStreams Access
                setUserData(resultObject);
                setOptIns(resultObject.optIns);
                setIsLoading(false);
            } )


    }, [authHeader, getActivePolicyForLossRunSubscription, props.userInfo.email]);

    useEffect(() => {
        trackGAPageView("/myprofile","My Profile")
    },[trackGAPageView])

    const getAccountHolderEmail = useCallback(() => {
        if (!_.isEmpty(userData)) {
            return userData.emails[0].value;
        }

        return ' ';
    }, [userData]);

    const getAccountHolderName = useCallback(() => {
        if (!_.isEmpty(userData)) {
            return `${userData.name.givenName} ${userData.name.familyName}`;
        }

        return (' ');
    }, [userData]);

    const getRole = (item) => {

        if(item.access==='BASIC' || (item.access==='ALL' && item.description==='View Resources/FAQ'))
        {
            return 'Basic User';
        }

        if(item.access==='SAFETYRESOURCES' || (item.access==='ALL' && item.description==='View Loss Control & Safety Resources'))
        {
            return 'Safety Resources';
        }

        if(item.access==='POLICY' || (item.access==='ALL' && item.description==='View policy details and policy documents, create Certificates of Insurance'))
        {
            return 'Policy';
        }

        if(item.access==='PREMIUMAUDIT' || (item.access==='ALL' && item.description==='View premium audit'))
        {
            return 'Premium Audit';
        }

        if(item.access==='BILLING' || (item.access==='ALL')&&item.description==='Make payments, view invoices')
        {
            return 'Billing';
        }

        if(item.access==='PAYROLL' || (item.access==='ALL' && item.description==='Enter payroll reports, view payroll documents'))
        {
            return 'Payroll Reporting' || item.access==='ALL';
        }

        if(item.access==='CLAIM' || (item.access==='ALL' && item.description==='File a new claim, view claim notes and reports'))
        {
            return 'Claims'
        }

        if(item.access==='USERADMIN' || (item.access==='ALL' && item.description === 'Add and remove users, change user permissions, and all other authorities'))
        {
            return 'Account Admin'
        }

        return ' '
    }

    const getAcessStatus = (item) => {
        if(item.isAccessGranted)
        {
            return <Icon icon="mi-check" />
        }

        return ' '
    }

    const getCell = ((item,index,property) => {
        if(item[property.id]==='emailNotifications')
        {
            return(
                <span className={styles.emailNotification}>
                    Email notifications for account events
                </span>
            )
        }

        if(item[property.id]==='description')
        {
            return(
                <div className={styles.description}>
                    <li>Billing invoice is ready</li>
                    <li>Billing invoice is unpaid and due soon</li>
                    <li>Account/Policy document has been posted</li>
                    <li>Payroll report is unfinished and due soon</li>

                </div>
            )
        }

        if(item[property.id]==='enroll')
        {
            if(!_.isEmpty(userData))
            {
                if(userData.optIns[0].selected)
                {
                    return "Yes"
                }

                return 'No'
            }
        }

        return null;
    })

    const renderRowData = (row) => {
        if (row.invoiceStreamCount > 1) {
            if (row.invoiceStreamName === undefined) {
                row.invoiceStreamName = [];
                row.invoiceStreams.forEach((itenm) => {
                    row.invoiceStreamName.push({
                        invName: itenm,
                        invId:Object.keys(row.invoiceStreamMap).find((key) => row.invoiceStreamMap[key] === itenm),
                        accountNumber: row.accountNumber
                    })
                })
            }

            return (
                <DataTable
                    columnsConfigurable={false}
                    data={row.invoiceStreamName}

                    defaultConfig={{
                        page: 0,
                        pageSize: 10
                    }}
                    id="basic"
                    showPagination={false}
                    showSearch={false}
                    isSorted={false}
                >
                    <DisplayColumn
                        header="Invoice Name"
                        id="invName"
                        path="invName"
                        textAlign="left"
                        columnProportion={0.69}
                    />

                </DataTable>
            )
        }

        return null;
    }


    const getNotificationName = (item) => NotificationDescription[item?.itemName]?.name;

    const getNotificationDesc = (item) => NotificationDescription[item?.itemName]?.value;

    const getNotificationAccess = (item) => {
        if (item.selected) {
            return <Icon icon="mi-check" />;
        }

        return '';
    };

    const showAlertForNotifications = useCallback(() => {
        ModalNext.showAlert({
            title: 'There was an error updating the activity',
            message: 'Please try again later',
            status: 'error',
            icon: 'mi-error-outline'
        });
    },[ModalNext]);

    const updateNotificationAlert = (e, item) => {
        e.preventDefault();
        setIsLoading(true);
        EnrollmentService.updateNotificationAlert(props.userInfo.email, item.portalOptInItemID, [], authHeader).then((result) => {
            if(result){
                const updatedOptIns = [...optIns];

                updatedOptIns.forEach((optins) => {
                    if (optins.portalOptInItemID === item.portalOptInItemID){
                        optins.selected = true;
                    }
                })
                setOptIns(updatedOptIns);
            } else {
                showAlertForNotifications();
            }
        }).catch(() => {
            showAlertForNotifications();
        }).finally(()=> {
            setIsLoading(false)
        })
    };

    const deleteNotificationAlert = (e, item) => {
        setIsLoading(true);
        EnrollmentService.deleteNotificationAlert(props.userInfo.email, item.portalOptInItemID, authHeader).then((result) => {
            if(result){
                return EnrollmentService.getUser(props.userInfo.email, authHeader);
            }

            showAlertForNotifications();

            return null;
        }).then((refreshedUser) => {
            if (refreshedUser) {
                setOptIns(refreshedUser.optIns);
            }
        }).catch(() => {
            showAlertForNotifications();
        }).finally(()=> {
            setIsLoading(false);
        })
    };
    const getNotificationAction = (item, index) => {
        if(item.selected) {
            return <Button style={{width:"min-content",background:"#003057"}} id={index} onClick={(e) => deleteNotificationAlert(e, item)}>Remove Receipt</Button>;
        }

        return <Button disabled= {disableLossRunSubscription && (item.itemName === 'LossRunSubscription' || item.itemName === 'LossRunSubscriptionXL')} style={{width:"min-content"}} id={index} onClick={(e) => updateNotificationAlert(e, item)}>Add Receipt</Button>;
    };

    const getGrantListData = useCallback(() => {
        const data = userData?.roles?.filter((role) => role.isAccessGranted === true && role.isInvoiceAccess !== true);

        return data
    }, [userData?.roles]);

    if (isLoading) {

        return <LoaderExt loaded={!isLoading} />;
    }

    const overrides = {
        '@field': {
            labelPosition: 'top',
            phoneWide: {
                labelPosition: 'top',
            },
        },
        accountHolderName: {
            value: getAccountHolderName(),
        },
        accountHolderEmail: {
            value: getAccountHolderEmail(),
        },
        accountAcessTableData:{
            data:userData.accountInformation
        },
        accessTableData:{
            data:getGrantListData()
        },
        notificationTable:{
            data:userData.optIns?.filter((item)=>item?.itemName!=="ClaimsUpdate" && item?.itemName!=="PremiumAudit") || []
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            getRole,
            getAcessStatus,
            getCell,
            handleRoute,
            getNotificationName,
            getNotificationDesc,
            getNotificationAccess,
            getNotificationAction,
            renderRowData
        },
        resolveClassNameMap: styles,
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

MyProfilePage.propTypes = {
    history: PropTypes.shape({
        location: PropTypes.shape({
            state: PropTypes.shape({
                redirectPath: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
        push: PropTypes.func.isRequired,
    }).isRequired,
};

export default withRouter(
    withViewModelService(withAuthenticationContext(MyProfilePage))
);
